import { Link } from 'react-router-dom'

export function StoreSelectView() {
  return (
    <div className="page page--store-select">
      <header className="store-select-header">
        <h1 className="store-select-title">Where do you want to go?</h1>
        <p className="store-select-subtitle">Pick a place to play!</p>
      </header>
      <nav className="store-select-grid" aria-label="Choose a store">
        <Link
          to="/grocery"
          className="store-select-card store-select-card--grocery"
          aria-label="Go to Grocery Store"
        >
          <span className="store-select-emoji" aria-hidden>🛒</span>
          <span className="store-select-name">Grocery Store</span>
          <span className="store-select-desc">Shop for fruits, veggies & more</span>
        </Link>
        <Link
          to="/bakery"
          className="store-select-card store-select-card--bakery"
          aria-label="Go to Bakery"
        >
          <span className="store-select-emoji" aria-hidden>🧁</span>
          <span className="store-select-name">Bakery</span>
          <span className="store-select-desc">Bake treats & shop for goodies</span>
        </Link>
        <Link
          to="/hardware"
          className="store-select-card store-select-card--hardware"
          aria-label="Go to Hardware Store"
        >
          <span className="store-select-emoji" aria-hidden>🔧</span>
          <span className="store-select-name">Hardware Store</span>
          <span className="store-select-desc">Build something & shop for tools</span>
        </Link>
      </nav>
      <footer className="store-select-footer">
        <Link to="/parent" className="home-parent-link">Parent</Link>
      </footer>
    </div>
  )
}
